
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M23.504 3.858c-3.03-2.206-5.187-2.158-6.006-2.026a.864.864 0 00-.56.357L5.925 17.384a3.917 3.917 0 00-.739 2.091l-.474 8.998a.897.897 0 001.216.885l8.41-3.216a3.921 3.921 0 001.77-1.358l11.008-15.19a.898.898 0 00.16-.677c-.134-.842-.779-2.883-3.771-5.059zm-9.141 20.486l-3.269 1.262a.304.304 0 01-.354-.099 8.252 8.252 0 00-1.72-1.648 8.363 8.363 0 00-2.096-1.13.307.307 0 01-.202-.307l.195-3.498.878-1.208s1.966-.27 4.533 1.597c2.563 1.866 2.914 3.821 2.914 3.821l-.88 1.21z"}})])
          )
        }
      }
    